import { Helmet } from 'react-helmet-async';
// sections
import { AllergenListView } from 'src/sections/allergen/view';

// ----------------------------------------------------------------------

export default function AllergenListPage() {
  return (
    <>
      <Helmet>
        <title>Alergénios</title>
      </Helmet>

      <AllergenListView />
    </>
  );
}
